var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('svgList'),_c('router-view'),_c('el-dialog',{staticClass:"login_dialog",attrs:{"title":"","visible":_vm.dialogVisible,"show-close":false,"width":"444px"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('loginDialogPage')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }